var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"nav-link",attrs:{"to":_vm.to,"active-class":"active"}},[_vm._t("default"),_c('i',{staticClass:"fas fa-angle-right pull-right"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }